import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import DefaultCardEmptyState from '../default/DefaultCardEmptyState';
import ContactCampaignCardEmptyState from './ContactCampaignCardEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
const CampaignCardEmptyState = props => {
  const {
    objectTypeId,
    objectId
  } = props;
  if (objectTypeId === CONTACT_TYPE_ID) {
    return /*#__PURE__*/_jsx(ContactCampaignCardEmptyState, {
      objectId: objectId
    });
  }
  return /*#__PURE__*/_jsx(DefaultCardEmptyState, Object.assign({}, props));
};
export default CampaignCardEmptyState;